/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);
/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();
window.theme = window.theme || {};
theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),
    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),
     // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
     // Search Page       
    $searchInput: $('.search-bar__input'),
    $searchSubmit: $('.search-bar__submit')
  }
};
theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();  
 theme.cartPage();
  theme.drawersInit();
};
theme.cartPage = function () {
  
    return;
  
  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');   
  });
};
theme.drawersInit = function () {
  // Add required classes to HTML
  $('#PageContainer').addClass('drawer-page-content');  
  $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');  
  theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {'onDrawerOpen': theme.searchFocus});
};
theme.searchFocus = function () {
  theme.cache.$searchInput.focus();
  // set selection range hack for iOS
  theme.cache.$searchInput[0].setSelectionRange(0, theme.cache.$searchInput[0].value.length);
};
theme.searchSubmit = function () {
  theme.cache.$searchSubmit.on('click', function(evt) {
    if (theme.cache.$searchInput.val().length == 0) {
      evt.preventDefault();
      theme.cache.$searchInput.focus();
    }
  });
};
theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });
  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);
    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };
    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer')
    };
    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }
    this.drawerIsOpen = false;
    this.init();
  };
  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };
  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;
    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }
    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }
    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }
    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();
    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;
    // Set focus on drawer
    this.trapFocus({
      $container: this.$drawer,
      $elementToFocus: this.$drawer.find('.drawer__close-button'),
      namespace: 'drawer_focus'
    });
    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }
    this.$nodes.parent.on('keyup.drawer', $.proxy(function (evt) {
      // close on 'esc' keypress
      if (evt.keyCode === 27) {
        this.close();
        return false;
      }
    }, this));
    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });
    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));
  };
  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();
    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
    this.drawerIsOpen = false;
    // Remove focus on drawer
    this.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });
    this.$nodes.page.off('.drawer');
    this.$nodes.parent.off('.drawer');
  };
  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  Drawer.prototype.trapFocus = function (options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + eventNamespace
      : 'focusin';
    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }
    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();
    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  };
  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  Drawer.prototype.removeTrapFocus = function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';
    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    $(document).off(eventName);
  };
  return Drawer;
})();
// Initialize shop's JS on docready
$(theme.init);
$(window).scroll(function() {
  if ($(window).scrollTop() > 0) {
    $('.site-header').addClass('triggerfix');
    $('.sticky-wrapper').removeClass('is-sticky');
  }
  else {
    $('.site-header').removeClass('triggerfix');
    $('.sticky-wrapper').removeClass('is-sticky');
  }
});
$(window).scroll(function() {
  if ($(window).scrollTop() > 10) {
    $('.top_bar').addClass('top_bar089');
  }
  else {
    $('.top_bar').removeClass('top_bar089');
  }
});
$(window).scroll(function() {
  if ($(window).scrollTop() > 0) {
    $('.breadcrumb').addClass('breadcrumb089');
    $('.breadcrumb').addClass('breadcrumb089');
  }
  else {
    $('.breadcrumb').removeClass('breadcrumb089');
    $('.breadcrumb').removeClass('breadcrumb089');
  }
});
setTimeout(function(){
$(".products-grid.owl-carousel").owlCarousel({
    loop:true,
    margin:10,
    nav:true,
    navContainer: ".new_featured00",
    navText: ['<a class="prev btn"><i class="fas fa-arrow-left" ></i></a>','<a class="next btn"><i class="fas fa-arrow-right" ></i></a>'],
    dots: false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:2
        },
        1000:{
            items:4
        }
    }
});
},5800);
$(document).on('click','.gotodesc', function(){
  var positiontop = $('#comeheredesc').position();
  var addingpos = positiontop.top+220;
  $('html, body').stop( true, false ).animate({ scrollTop: addingpos}, 500);
});
$(document).on('submit','#create_customer',function(){
  var lenpss = $('#CreatePassword').val().length;
  if(lenpss >= 8){
    return true;
    $('.psswrd').css({'color':'grey'});
  }
  else{
    $('.psswrd').css({'color':'red'});
    return false;
  }
});
$(function(){
  $('div').removeClass('wow');
  $('div').removeClass('animated');
  $('div').removeClass('fadeInUp');
});
$(function(){
  var get_cookie = Cookies.get('prodpass');
  //console.log(get_cookie);
  var inputgetpss = $('.getpss').val();
  if(get_cookie == inputgetpss){
    $('.hideifcookienotset').show();
    $('.passbtns').hide();
  }
  else{
    $('.passbtns').show();
  }
});
$(document).on('click','.addToCart_0',function(){
  var productSelect = $('#productSelect').val();
    var get_cookie = Cookies.get('prodpass');
    //console.log(get_cookie);
      var inputgetpss = $('.getpss').val();
     if(get_cookie == inputgetpss){
      $('.hideifcookienotset').show();
      $('.passbtns').hide();
    }
    else{
      $('.poppass').show();
    }
});
$(document).on('click','.closepss',function(){
  $('.poppass').hide();
});
$('.donepss').click(function(){
    var skincepss = $('.skincepss').val();
    var inputgetpss = $('.getpss').val();
    if(inputgetpss == skincepss){
       Cookies.set('prodpass', inputgetpss, { expires: 36555 });
       $('.errormsg').html('Correct!');
      setTimeout(function(){
       $('.poppass').hide();
      },300)
      $('.hideifcookienotset').show();
      $('.passbtns').hide();
    }
    else{
      $('.errormsg').html('Incorrect Password, please contact dermsilk at 1(1866)405-6608');
    }
});
$('.getpss').keyup(function(){
  $('.errormsg').html('');
});
if($(window).width() < 830){
  $(document).on('click','.site-footer .grid__item.wide--one-third.post-large--one-third.large--one-third.medium--one-half h4',function(){
    if($(this).next().css('display') == 'none'){
      $(this).next().slideDown();
      $(this).children('.minus_f').css('display','inline-block');
      $(this).children('.plus_f').css('display','none');
    }
    else{
      $(this).next().slideUp();    
      $(this).children('.minus_f').css('display','none');
      $(this).children('.plus_f').css('display','inline-block');
    }
  })
}
$('#showTagsFilter').click(function(){
  $('.collection_sidebar').addClass('show_side');
  $('body').css('overflow','hidden');
});
$('.close_sidebr').click(function(){
  $('.collection_sidebar').removeClass('show_side');
  $('body').css('overflow','auto');
});
$('.spcld span').click(function(){
  $(this).siblings('input').trigger('click');
});

$(document).ready(function(){
   var allPanels = $('.template-product .accordion > div').hide();
   $('.template-product .accordion > .div_0').show();
   $('.template-product .accordion > h3').click(function() {
     if($(this).next().css('display') == 'block'){
       $(this).next().slideUp();
       $(this).children('.minus_o').css('display','none');
       $(this).children('.plus_o').css('display','inline-block');
     }
     else{
      allPanels.slideUp();
       $('.minus_o').hide();
       $('.plus_o').show();
       $(this).children('.minus_o').css('display','inline-block');
       $(this).children('.plus_o').css('display','none');
       $(this).next().slideDown();
     }
   });
});
$(function(){
    var get_wind = window.location.href;
    if(get_wind.indexOf('?email_cus=') > -1){
      var get_windspl = get_wind.split('?email_cus=');
      $('.section-header').append('<p>Please Wait fetching email..</p>');
      setTimeout(function(){
        $('.order-track-input').val(get_windspl[1]);
        $('.find-order .btn').trigger('click');
      },14000);
    }
  });

$(document).on("click",".close",function(){
   $(".form-success").hide();
   $(".over_lay").hide();
});


// var winloccis = window.location.href;
// if(winloccis.indexOf('?frlist=0') > -1){
//   setTimeout(function(){
//    $('html, body').animate({
//     scrollTop: $("#sckhhrr").offset().top -330
//   }, 500)
//   $(".pro_form_1").slideDown();
//   },800)
// }